import React from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components';
// import helper from '../../../utils/helper';
// import CustomizePopup from '../CustomizePopup';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import { TextField, makeStyles } from '@material-ui/core';

const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
  /* height: 100%; */
  /* max-height: 400px; */
  /* max-height: 20px; */
  position: relative;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
`
const Table = styled.table`
  text-align: center;
  font-family: Open Sans;
  border-collapse: collapse;
  /* border: 3px solid #ddd; */
  width: 100%;
  table-layout: auto;
  position: relative;
`
const TableRow = styled.tr`
  padding: 8px;
  background: ${({checked}) => checked ? 'linear-gradient(0deg, rgba(146, 64, 201, 0.16), rgba(146, 64, 201, 0.16)), #FFFFFF !important' : '#FFFFFF'};
  &:nth-child(odd){
    background: #efefef;
  }
  /* &:hover{
    background-color: #ddd;;
  } */
`
const TableRowHeader = styled.tr`
  background: #F9F9F9;
  box-shadow: 0px 3px 6px rgba(26, 26, 26, 0.12), 0px 0px 1px rgba(26, 26, 26, 0.24);
  padding: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  /* color: #A0A2A6; */
  color: #58595B;
  vertical-align: middle;
  transform: scale(1.0001);

`
const TH = styled.th`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  padding: 18px 12px;
  align-content: center;
  vertical-align: middle;
  box-shadow: 0px 6px 6px -6px rgba(26, 26, 26, 0.12),
              0px 0px 1px -2px rgba(26, 26, 26, 0.24);
  background: #F9F9F9;
  color: #7C3F88;
  position: sticky;
  top: 0;
  z-index: 999;
  transform: translateZ(1px);
`
const THContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const TD = styled.th`
  padding: 18px 12px;
  color: #6A6A6A;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  transition: all 200ms ease-in-out;
  &:hover{
    font-family: Open Sans;
    font-weight: ${({ isHoverable }) => isHoverable ? 500 : 'normal'};
  }
`
const TDContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: relative; */
`
const ImageCell = styled.img`
  height: 1.5em;
  width: auto;
  margin-right: .5em;
`
const TableFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* height: 5em; */
  width: 100%;
  padding: 1em 2em;
  flex-wrap: wrap;
  background: #FFFFFF;
  box-shadow: 0px 0px 1px rgba(68, 68, 68, 0.12), 0px -1px 2px rgba(68, 68, 68, 0.16);
  transform: scale(1.0000000001);
  @media screen and (max-width: 425px) {
    /* flex-direction: column; */
    height: auto;
    padding: .5em .5em;
    & div {
      &:nth-child(1){
        margin-bottom: .5em
      };
      &:nth-child(2){
        margin-bottom: .5em;
        margin: 0 auto .2em auto;
      }
    }
  }
`
const TotalElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & span{
    font-family: Open Sans;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #A0A2A6;
    &:first-child{
      font-family: Open Sans;
      font-weight: 500;
      margin-right: .5em;
    }
  }
`
const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #F8F8F8;
  padding: 8px 10px;
  border-radius: 40px;
`
const DoubleArrowImg = styled.img`
  width: 1.5em;
  height: auto;
  cursor: pointer;
  margin: 0 .2em;
`
const ArrowContainer = styled.div`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px;
  width: 24px;
  height: 24px;
  /* Ripley / Morado */
  background: #7C3F88;
  border-radius: 28px;
  margin: 0 .2em;
  cursor: pointer;
`
const PageNumbers = styled.div`
  display: flex;
  align-items: center;
`
const NumberPage = styled.span`
  font-family: Open Sans;
  font-weight: ${ ({ active }) => active ? 700 : 'normal'};
  margin: 0 .7em;
  cursor: pointer;
`
const ShowElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & span{
    font-family: Open Sans;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #A0A2A6;
  }
`
const useInputStyles = makeStyles(theme => ({
  root: {
    minWidth: '1.8em',
    maxWidth: '2.2em',
    height: '2em',
    margin: '0 .5em',
    '& input': {
      padding: '7px 4px 4px',
      textAlign: 'center'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: '#dcdcdc',
      '&$focused': {
        borderColor: 'red'
      }
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#9240C9',
      borderWidth: '.5px'
    }
  },
  focused: {}
}));

const voidFunc = () => { }

const CustomTable = ({ rows = [], columns = [], currentPage, total, changePage=voidFunc, checkbox = false, perPage, onChangePerPage=voidFunc, onClickCheckBox=voidFunc, totalPages }) => {
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [popContent, setPopContent] = useState({});
  const inputClasses = useInputStyles();
  // const totalPages = Math.ceil(parseInt(total) / parseInt(perPage));

  // const handlePopoverOpen = (event, rowValue) => {
  //   const rowObject = helper.removeKey('value', rowValue)
  //   setPopContent(rowObject);
  //   console.log(rowObject);
  //   setAnchorEl(event.currentTarget);
  // };

  // const handlePopoverClose = () => {
  //   setAnchorEl(null);
  // };

  // const open = Boolean(anchorEl);

  const renderColumns = (columns) => {
    return columns.map(({ id, label, format, hasPopup, cellStyle, ...rest }) => (
      <TH key={id} style={{ ...rest }}>
        <THContainer>
          {label}
          {/* {hasPopup && <InfoIcon src={require('../../../../assets/images/info_red.svg')} />} */}
        </THContainer>
      </TH>
    ))
  }

  const renderRows = (rows, columns, checkbox, onClickCheckBox) => {
    return rows.map((row, rowIndex) => {
      return (
        <TableRow key={`${rowIndex} `} checked={row.checked}>
          {/* {checkbox && (
            <TD
              key={`rowIndex-checkbox-${rowIndex}`}
            >
              <TDContainer>
                {
                  row.checked
                    ? <CheckboxImg onClick={() => onClickCheckBox(row, rowIndex)} src={require('../../../../assets/images/checkbox_on.svg')} />
                    : <CheckboxImg onClick={() => onClickCheckBox(row, rowIndex)} src={require('../../../../assets/images/checkbox_off.svg')} />
                }
              </TDContainer>
            </TD>

          )} */}
          {columns.map(column => {
            const rowValue = row[column.id];
            return (
              <TD
                key={`${rowIndex} -${column.id} `}
                isHoverable={column.hasPopup}
              >
                <TDContainer
                  // onMouseEnter={column.hasPopup ? (e) => handlePopoverOpen(e, rowValue) : null}
                  // onMouseLeave={column.hasPopup ? handlePopoverClose : null}
                  style={column.cellStyle || {}}>
                  {
                    // column.type === 'download'
                    //   ? <IconFileContainer><FileTypeImg src={require('../../../../assets/images/pdf-file.svg')} /> </IconFileContainer>
                    //   : (typeof rowValue === 'object' && rowValue !== null)
                    //     ? (
                    //       <>
                    //         {rowValue.img && <ImageCell src={rowValue.img} />}
                    //         {column.format ? column.format(rowValue.value) : rowValue.value}
                    //       </>
                    //     )
                    //     : column.format ? column.format(rowValue) : rowValue
                    (typeof rowValue === 'object' && rowValue !== null)
                    ? (
                      <>
                        {rowValue.img && <ImageCell src={rowValue.img} />}
                        {column.format ? column.format(rowValue.value) : rowValue.value}
                      </>
                    )
                    : column.format ? column.format(rowValue) : rowValue
                  }
                </TDContainer>
              </TD>
            );
          })}
        </TableRow>
      );
    })
  }

  const getPages = (current, total) => {
    let pages = []
    if (current > 2 && current !== total) {
      pages = total > 3 ? [current - 1, current, current + 1] : [1, 2, 3]
    } else if (current === total && total > 2) {
      pages = [current - 2, current - 1, current]
    } else if (current === total && total === 1) {
      pages = [1]
    } else {
      pages = total === 2 ? [1, 2] : [1, 2, 3]
    }
    return pages
  }

  const renderPageNumbers = (current, totalPages, changePage) => {
    const pages = getPages(current, totalPages);
    return pages.map((p, i) => <NumberPage key={i} active={p === current ? true : false} onClick={() => changePage(p, perPage)}>{p}</NumberPage>)
  }

  return (
    <>
      <TableContainer>
        <Table>
          <thead>
            <TableRowHeader>
              {checkbox && (
                <TH>
                  <THContainer style={{ minWidth: 90 }}>
                  </THContainer>
                </TH>)}
              {renderColumns(columns)}
            </TableRowHeader>
          </thead>
          <tbody>
            {renderRows(rows, columns, checkbox, onClickCheckBox)}
          </tbody>
        </Table>
        {/* <CustomizePopup
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          popContent={popContent}
          disableRestoreFocus
          popUpColumns={popUpColumns}
        /> */}
      </TableContainer>
        {total > 0 && (
          <TableFooter>
              <>
                <TotalElementCont>
                  <span>{total}</span>
                  <span>elementos en total</span>
                </TotalElementCont>
                <PaginationContainer>
                  <DoubleArrowImg onClick={() => currentPage === 1 ? null : changePage(1, perPage)} src={require('../../../../assets/icons/page-first.svg')} />
                  <ArrowContainer onClick={() => currentPage === 1 ? null : changePage(currentPage - 1, perPage)}>
                    <NavigateBefore style={{ color: '#fff' }} />
                  </ArrowContainer>
                  <PageNumbers>
                    {renderPageNumbers(currentPage, totalPages, changePage)}
                  </PageNumbers>
                  <ArrowContainer onClick={() => currentPage === totalPages ? null : changePage(currentPage + 1, perPage)}>
                    <NavigateNext style={{ color: '#fff' }} />
                  </ArrowContainer>
                  <DoubleArrowImg onClick={() => currentPage === totalPages ? null : changePage(totalPages, perPage)} src={require('../../../../assets/icons/page-last.svg')} />
                </PaginationContainer>
                <ShowElementCont>
                  <span>Mostrar</span>
                  <TextField
                    variant='outlined'
                    value={perPage}
                    onChange={onChangePerPage}
                    InputProps={{ classes: inputClasses }} />
                  <span>elementos por pagina</span>
                </ShowElementCont>
              </>
          </TableFooter>
        )
      }
    </>
  )
}

export default CustomTable
